export enum SendEmailTemplate {
  ENDOZONE_CHAT_HISTORY = 'endozoneChatHistory',
}

export interface EndozoneChatHistoryResource {
  entryId?: string;
  title: string;
  description: string;
  imgUrl?: string;
  url?: string;
  [key: string]: unknown;
}

export interface EndozoneChatHistoryItem {
  timeStamp: string;
  content: string;
  resources?: EndozoneChatHistoryResource[];
}

export interface EndozoneChatHistoryTemplateVariables {
  chatHistory: EndozoneChatHistoryItem[];
  chatCreatedAt: string;
}

export interface SendEmailRequest {
  template: SendEmailTemplate.ENDOZONE_CHAT_HISTORY;
  templateVariables: EndozoneChatHistoryTemplateVariables;
}
